import { useEffect as d, useRef as a, useCallback as o } from "react";
import { addCopilotInstruction as v, addCopilotTool as C, addCopilotContext as y } from "../global-state.js";
function E(e) {
  const t = e.isEnabled ?? !0;
  return d(() => {
    if (t === !1)
      return;
    const n = v(e);
    return () => n();
  }, [t, e.instruction]);
}
function A(e) {
  const t = e.isEnabled ?? !0, n = "handler" in e ? e.handler : void 0, s = a(n);
  s.current = n;
  const c = n != null, i = a(e.render);
  i.current = e.render;
  const f = e.render != null, u = a(e.needsApproval);
  u.current = e.needsApproval;
  const l = e.needsApproval != null, h = e.humanInTheLoop === !0;
  return d(() => {
    if (t === !1)
      return;
    const p = {
      name: e.name,
      description: e.description,
      requestSchema: e.requestSchema,
      responseSchema: e.responseSchema,
      needsApproval: l ? (r) => typeof u.current == "function" ? u.current(r) : u.current === !0 : void 0,
      render: f ? (r) => i.current?.(r) : void 0
    }, m = C(
      e.type === "client" ? h ? {
        ...p,
        type: e.type,
        humanInTheLoop: !0,
        render: (r) => i.current?.(r)
      } : {
        ...p,
        type: e.type,
        handler: (r) => s.current?.(r)
      } : {
        ...p,
        type: e.type,
        handler: (r) => s.current?.(r),
        isStreaming: e.isStreaming
      }
    );
    return () => m();
  }, [
    t,
    e.type,
    e.name,
    e.description,
    e.requestSchema,
    e.responseSchema,
    l,
    h,
    "isStreaming" in e ? e.isStreaming : !1,
    c,
    f
  ]);
}
function R(e) {
  const t = e.isEnabled ?? !0, n = a(e);
  n.current = e;
  const s = o(() => typeof n.current.value == "function" ? n.current.value() : n.current.value, []);
  return d(() => {
    if (t === !1)
      return;
    const c = y({
      description: e.description,
      value: s
    });
    return () => c();
  }, [t, e.description]);
}
export {
  R as useCopilotContext,
  E as useCopilotInstruction,
  A as useCopilotTool
};
